var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-2 text-center"},[_c('LibraryLogo',{attrs:{"library":_vm.library,"size":"72"}}),_c('a',{staticClass:"stretched-link",attrs:{"href":"/user/profile"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }